import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { Input } from '../../components';
import { InputNumberProps } from 'antd/lib/input-number';

// Antd v3 shipped antd/lib/_util/isNumeric; removed in v5, so inline it.
const isNumeric = (value: unknown): boolean => !isNaN(Number.parseFloat(value as string)) && isFinite(value as number);

interface Props {
  name: string;
  label?: ReactNode;
  size?: InputNumberProps['size'];
  min?: InputNumberProps['min'];
  max?: InputNumberProps['max'];
  precision?: number;
  isCurrency?: boolean;
  disabled?: boolean;
}

export default function InputField({ name, size, precision = 2, ...bag }: Props) {
  return (
    <Field name={name}>
      {({ field: { value, ...field }, form: { errors, setFieldValue } }: FieldProps) => {
        function handleChange(v: number | string | null) {
          setFieldValue(name, isNumeric(v) ? Number(v) : 0);
        }
        return (
          <div>
            <Input.Number
              precision={precision}
              error={getIn(errors, name)}
              size={size}
              defaultValue={value}
              {...field}
              {...bag}
              onChange={handleChange}
            />
          </div>
        );
      }}
    </Field>
  );
}
